export var TEXT = 'text';
export var RICH_TEXT = 'rich-text';
export var NUMBER = 'number';
export var TODO = 'todo';
export var NAME = 'name';
export var DATE = 'date';
export var CREATED_AT = 'created-at';
export var UPDATED_AT = 'updated-at';
export var USER = 'user';
export var CREATED_BY = 'created-by';
export var UPDATED_BY = 'updated-by';
export var SELECT = 'select';
export var MULTI_SELECT = 'multi-select';
export var USERS = 'users';
export var NOTES = 'notes';
export default {
  NAME: NAME,
  TEXT: TEXT,
  RICH_TEXT: RICH_TEXT,
  NUMBER: NUMBER,
  TODO: TODO,
  DATE: DATE,
  CREATED_AT: CREATED_AT,
  UPDATED_AT: UPDATED_AT,
  USER: USER,
  CREATED_BY: CREATED_BY,
  UPDATED_BY: UPDATED_BY,
  SELECT: SELECT,
  MULTI_SELECT: MULTI_SELECT,
  USERS: USERS,
  NOTES: NOTES
};